import {useContext} from "react";
import QRCodeIconContext from "../../../../../../../../contexts/qr-code/icon/QRCodeIconContext";
import {Group} from "@mantine/core";
import QRCodeIcon from "../../../../../../../../api/qr-code/icon/QRCodeIcon";
import ListItem from "./list-item/ListItem";
import ToolBar from "../../../_utils/horizontal-list-view/toolbar/ToolBar";
import QRCodeStyleViewContext from "../../../QRCodeStyleViewContext";
import SubView from "../../SubView";

/**
 * More icons view.
 * @author Kacper Faber
 * @QRCodeStyleViewTypes more-icons
 * @since 0.1.9
 */
function MoreIconsView() {
    /**
     * QRCodeIconContext
     * @author Kacper Faber
     * @since 0.1.9
     */
    const iconContext = useContext(QRCodeIconContext);

    const {setActiveView} = useContext(QRCodeStyleViewContext);

    /**
     * Render the QR Code Icon as an item
     * @author Kacper Faber
     * @since 0.1.9
     */
    const renderItem = (icon: QRCodeIcon) => {
        return (
            <ListItem
                icon={icon}
            />
        );
    }

    /**
     * On upload button is clicked
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onUploadButtonClick = () => {
        setActiveView('upload-icon');
    }

    return (
        <SubView viewBack="index">
            <Group>
                <ToolBar
                    label="WIĘCEJ IKON"
                    moreButton="Wyślij nową"
                    onMoreButtonClick={onUploadButtonClick}
                />

                {iconContext.data?.results?.map(renderItem)}
            </Group>
        </SubView>
    );
}

export default MoreIconsView;